(() => {
  'use strict';
  const headers = new Map();
  const desktop = () => window.matchMedia('(min-width: 990px)').matches;
  const closeDetails = header => header.querySelectorAll('details[open]').forEach(details => details.removeAttribute('open'));
  function init(scope = document) {
    const found = [...(scope.matches?.('[data-gt-header]') ? [scope] : []), ...scope.querySelectorAll('[data-gt-header]')];
    found.forEach(header => {
      if (headers.has(header)) return;
      const shell = header.closest('[id^="shopify-section-"]') || header;
      shell.classList.add('gt-header-shell');shell.dataset.stickyMode = header.dataset.stickyMode;
      const toggle = header.querySelector('[data-header-toggle]'), menu = header.querySelector('[data-header-mobile]');
      const state = { shell, previousY: window.scrollY, close: null, measure: null, observer: null };
      const setOpen = (open, focus = false) => {
        if (!menu || !toggle) return;
        menu.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));toggle.setAttribute('aria-label', open ? 'Cerrar menú' : 'Abrir menú');
        toggle.querySelector('[data-menu-open-icon]').hidden = open;toggle.querySelector('[data-menu-close-icon]').hidden = !open;
        if (open) shell.classList.remove('gt-header-shell--hidden');else closeDetails(menu);
        if (focus) toggle.focus();
      };
      state.close = focus => setOpen(false, focus);
      toggle?.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
      header.querySelector('[data-header-close]')?.addEventListener('click', () => setOpen(false, true));
      menu?.addEventListener('click', event => { if (event.target.closest('a')) setOpen(false); });
      const input = header.querySelector('[data-header-search]'), clear = header.querySelector('[data-search-clear]');
      const updateClear = () => { if (clear) clear.hidden = !input?.value; };
      input?.addEventListener('input', updateClear);
      clear?.addEventListener('click', () => { input.value = '';input.dispatchEvent(new Event('input', { bubbles: true }));input.focus(); });updateClear();
      header.querySelectorAll('.gt-header__menu:not(.gt-header__menu--mobile)>.gt-header__dropdown, .gt-header__menu:not(.gt-header__menu--mobile)>li>.gt-header__dropdown').forEach(details => details.addEventListener('toggle', () => {
        if (!details.hasAttribute('open')) return;
        header.querySelectorAll('.gt-header__nav-bar .gt-header__dropdown[open]').forEach(other => { if (other !== details) other.removeAttribute('open'); });
        shell.classList.remove('gt-header-shell--hidden');
      }));
      header.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        if (menu && !menu.hidden) { event.preventDefault();setOpen(false, true); }
        else { const open = header.querySelector('details[open]');if (open) { event.preventDefault();closeDetails(header);open.querySelector('summary')?.focus(); } }
      });
      state.measure = () => { header.style.setProperty('--gt-header-height', `${header.offsetHeight}px`);if (desktop()) setOpen(false);shell.classList.remove('gt-header-shell--hidden'); };
      if (typeof ResizeObserver !== 'undefined') { state.observer = new ResizeObserver(() => header.style.setProperty('--gt-header-height', `${header.offsetHeight}px`));state.observer.observe(header); }
      headers.set(header, state);state.measure();
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('click', event => {
    headers.forEach((state, header) => { if (!header.contains(event.target)) { state.close();closeDetails(header); } });
  });
  window.addEventListener('scroll', () => {
    headers.forEach((state, header) => {
      const y = window.scrollY;
      const interacting = header.contains(document.activeElement) || header.querySelector('[aria-expanded="true"],details[open]');
      const hide = header.dataset.stickyMode === 'reveal' && y > 180 && y > state.previousY && !interacting;
      state.shell.classList.toggle('gt-header-shell--hidden', !!hide);state.previousY = y;
    });
  }, { passive: true });
  window.addEventListener('resize', () => headers.forEach(state => state.measure()), { passive: true });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:select', event => headers.forEach((state, header) => { if (event.target.contains(header)) state.shell.classList.remove('gt-header-shell--hidden'); }));
  document.addEventListener('shopify:section:unload', event => headers.forEach((state, header) => { if (event.target.contains(header)) { state.observer?.disconnect();headers.delete(header); } }));
})();
